export default __webpack_public_path__ + "static/puro-img-60bb544a284e6182bb18444f2e76c626.png";